/* eslint-disable no-nested-ternary */
import React from 'react';
import Breadcrumbs from '../../Breadcrumbs';
import LayoutContainer from '../../LayoutContainer';
import './styles.css';

const BreadcrumbsBottom = ({ breadcrumbs }) => {
  if (breadcrumbs && !!breadcrumbs.length)
    return (
      <LayoutContainer className="Landing__breadcrumbs">
        <Breadcrumbs
          data={[
            {
              breadcrumb: 'Localsearch',
              url: '/',
            },
            {
              url: 'sitemap',
              breadcrumb: 'Sitemap',
            },
            ...breadcrumbs,
          ]}
        />
      </LayoutContainer>
    );
  return '';
};

export default BreadcrumbsBottom;
